class LpAssetGallery extends HTMLElement {
  connectedCallback() {
    this.mainImage = this.querySelector('[data-gallery-main]');
    this.thumbnails = [...this.querySelectorAll('[data-gallery-thumb]')];

    for (const thumbnail of this.thumbnails) {
      thumbnail.addEventListener('click', this.handleThumbnailClick);
    }
  }

  disconnectedCallback() {
    for (const thumbnail of this.thumbnails || []) {
      thumbnail.removeEventListener('click', this.handleThumbnailClick);
    }
  }

  handleThumbnailClick = (event) => {
    const thumbnail = event.currentTarget;
    if (!(thumbnail instanceof HTMLButtonElement) || !this.mainImage) return;

    this.mainImage.src = thumbnail.dataset.gallerySrc || '';
    this.mainImage.alt = thumbnail.dataset.galleryAlt || '';

    for (const item of this.thumbnails) {
      item.setAttribute('aria-current', item === thumbnail ? 'true' : 'false');
    }
  };
}

if (!customElements.get('lp-asset-gallery')) {
  customElements.define('lp-asset-gallery', LpAssetGallery);
}
